module.exports = __webpack_public_path__ + "img/manda_021.89ff40da.png";